import React from 'react'
import Card from './Card'
import {useNavigate} from 'react-router-dom'
import Text from '../Text/Text'

export default function FolderCard({folder,to='',...props}) {
    const navigate=useNavigate()

    return (
        <Card
            {...props}
            className="flex !flex-col items-center justify-center p-2 aspect-video lg:aspect-auto rounded-lg cursor-pointer bg-primary-400"
            onClick={() => navigate(to)}
        >
            <i className="text-3xl text-dark bi bi-folder"></i>
            <Text className="!align-middle font-medium">
                {folder.title}
            </Text>
        </Card>
    )
}
